import { render, staticRenderFns } from "./AboutDetails.vue?vue&type=template&id=44ef3e6e&"
import script from "./AboutDetails.vue?vue&type=script&lang=js&"
export * from "./AboutDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports